var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFillArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8545 7.6842C13.3636 7.39028 13.3636 6.65547 12.8545 6.36154L3.0227 0.685141C2.51361 0.391217 1.87724 0.75862 1.87724 1.34647V12.6993C1.87724 13.2871 2.5136 13.6545 3.02269 13.3606L12.8545 7.6842Z",
    fill: "#80552D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8545 7.6842C13.3636 7.39028 13.3636 6.65547 12.8545 6.36154L3.0227 0.685141C2.51361 0.391217 1.87724 0.75862 1.87724 1.34647V12.6993C1.87724 13.2871 2.5136 13.6545 3.02269 13.3606L12.8545 7.6842Z",
    fill: "url(#paint0_linear_568_25656)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.146 6.66025C13.33 7.00376 13.2329 7.46573 12.8545 7.68417L3.0227 13.3606C2.5136 13.6545 1.87724 13.2871 1.87724 12.6992V1.34644C1.87724 0.901105 2.24246 0.582285 2.64088 0.581665V11.4027C2.64088 11.9906 3.27724 12.358 3.78633 12.0641L13.146 6.66025Z",
    fill: "#FFC692"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568_25656",
    x1: 2.13001,
    y1: 0.608697,
    x2: 2.43436,
    y2: 13.3913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520733,
    stopColor: "#FFC692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#FFB26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1832E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFillArrow);
export default __webpack_public_path__ + "static/media/right-fill-arrow.0871410dc88b102fdd9c3b05e24f670f.svg";
export { ForwardRef as ReactComponent };